import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HapticsService } from './haptics.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [HapticsService],
})
export class HapticsModule {}
